import { defineStore } from 'pinia'

export const useDemoStore = defineStore('demo', {
  state: () => ({
    isUnlocked: false,
    demoKey: '',
    refreshJob: null,
  }),
  actions: {
    setUnlocked(value) {
      this.isUnlocked = Boolean(value)
    },
    setDemoKey(value) {
      this.demoKey = String(value || '')
    },
    setRefreshJob(job) {
      this.refreshJob = job || null
    },
    clearRefreshJob() {
      this.refreshJob = null
    },
    resetDemoSession() {
      this.isUnlocked = false
      this.demoKey = ''
      this.refreshJob = null
    },
  },
  persist: true,
})
